<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<!-- AWS访问秘钥 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.accessKeyId')}}: </span>
	                <span class="expand-value">{{ row.accessKeyId }}</span>
	            </Col>
	            <!-- 事件时间 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.caseTime')}}: </span>
	                <span class="expand-value">{{ row.eventTime }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- AWS地域 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.awsRegion')}}: </span>
	                <span class="expand-value">{{ row.awsRegion }}</span>
	            </Col>
	            <!-- 只读 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.readOnly')}}: </span>
	                <span class="expand-value">{{ row.readOnly }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 错误代码 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.errorCode')}}: </span>
	                <span class="expand-value">{{ row.errorCode }}</span>
	            </Col>
	            <!-- 请求ID -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.requestId')}}: </span>
	                <span class="expand-value">{{ row.requestId }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 事件ID -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.eventId')}}: </span>
	                <span class="expand-value">{{ row.eventId }}</span>
	            </Col>
	            <!-- 源IP地址 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.invokedBy')}}: </span>
	                <span class="expand-value">{{ row.invokedBy }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 事件名称 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.caseName')}}: </span>
	                <span class="expand-value">{{ row.eventName }}</span>
	            </Col>
	            <!-- 用户名 -->
	            <Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.userName')}}: </span>
	                <span class="expand-value">{{ row.userName }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<!-- 事件源 -->
	        	<Col span="12">
	                <span class="expand-key">{{$t('CloudTrailSecurity.eventSource')}}: </span>
	                <span class="expand-value">{{ row.eventSource }}</span>
	            </Col>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>


// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_list/TableExpand.vue